export const ACCESS_TYPES = {
  READ: 'read',
  READ_WRITE: 'readWrite',
  NONE: 'none',
};
